export function breadcrumbInBanner () {
    const breadcrumbWrapper = document.querySelector('.breadcrumbWrapper');
    const breadcrumbInBannerSelector = document.querySelector('.js-breadcrumbInBanner');
    if(breadcrumbInBannerSelector) {
        breadcrumbWrapper.classList.add('breadcrumbInBanner');
    }
}